import MemberList from "../models/MemberList";

const MemberListStore = MemberList.create({
  members: [],
  sortColumn: "createdAt",
  sortOrder: "descend"
});

export default MemberListStore;
